<div class="modal-container">
  <div mat-dialog-title
       class="modal-header">
    <h1 class="modal-title">{{data.title}}</h1>
  </div>

  <div mat-dialog-content
       class="modal-content">

    <div class="designer-invalid"
         *ngFor="let collision of data.collisions">
      <div class="invalid-message-container">
        <h3>Version collision for package: <strong>{{ collision.conflictingPackage }}</strong></h3>

        <div *ngFor="let collisionPath of collision.paths; let i = index">
          <span *ngFor="let pathSegment of formatVersionedPath(collisionPath, collision.conflictingPackage); let last = last"
                [class.invalid-message]="pathSegment.isConflicting"
                style="display: inline;">
            {{ pathSegment.segment }}<b *ngIf="!last"> / </b>
          </span>
        </div>
      </div>
    </div>

  </div>

  <div mat-dialog-actions
       class="modal-toolbar commands">
    <button mat-button
            class="datex-button secondary"
            (click)="onCloseClicked()">
      Close
    </button>
  </div>
</div>